const STORAGE_KEY = "developer_mode";

export function isDeveloperModeEnabled() {
  return localStorage.getItem(STORAGE_KEY) === "true";
}

export function setDeveloperModeEnabled(enabled) {
  localStorage.setItem(STORAGE_KEY, enabled ? "true" : "false");
}
